module.exports = __webpack_public_path__ + "static/media/new-arrival-product-2.74cc8223.png";